/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/021-video-camera': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M6 4.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zm-6 0a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zm12 5V8c0-.55-.45-1-1-1H1c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1h10c.55 0 1-.45 1-1v-1.5l4 2.5V7l-4 2.5zM10 12H2V9h8v3z"/>'
  }
})
